export interface CompteProfilProProfileDetails {
  success?: boolean;
  status?: string;
  fonction?: string;
  statut?: StatutEnum;
  domaineDactivite?: Array<string>;
  email?: string;
  telephoneFixe?: string;
  telephoneMobile?: string;
  gestionnaire?: boolean;
  gestionnaireNaturel?: boolean;
  droitCertification?: boolean;
  idnRattachement?: string;
  locked?: boolean;
  codeCsn?: string;
  premierArreteDeNomination?: string;
  dernierArreteDeNomination?: string;
  parutionAuJO1?: string;
  parutionAuJO2?: string;
  premierePrestationDeSerment?: string;
  dernierePrestationDeSerment?: string;
  typeEntite?: string;
  mandats?: Array<string>;
  champsVerrouillables?: string[];
}

export type StatutEnum = 'Salarié' | 'Non salarié';
export const StatutEnum = {
  SALARIE: 'Salarié' as StatutEnum,
  NONSALARIE: 'Non salarié' as StatutEnum,
};
